var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 13,
    viewBox: "0 0 48 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4851 5.89428C47.4851 3.16598 45.5843 1.24707 42.9197 1.24707C39.5275 1.24707 37.2539 3.71164 37.2539 7.23116C37.2539 9.97765 39.1728 11.8784 41.8829 11.8784C44.3475 11.8784 46.1846 10.687 46.9394 8.78629H44.202C43.8382 9.37742 43.0652 9.75029 42.1194 9.75029C40.6643 9.75029 39.7549 8.78629 39.673 7.42214H47.3305C47.4305 6.90376 47.4851 6.45813 47.4851 5.89428ZM39.8822 5.57598C40.1277 4.32096 41.3464 3.32058 42.8196 3.32058C44.0929 3.32058 45.0569 4.24821 45.0569 5.57598H39.8822Z",
    fill: "#2E4369"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8945 11.6328L30.3856 9.01359C31.8862 9.3137 32.1136 8.46792 32.5046 6.43079L32.6956 5.42131C33.2413 2.57478 34.3417 1.15606 37.4883 1.53803L36.9972 4.1572C35.4967 3.85709 35.2329 4.99388 34.8964 6.75819L34.7054 7.76766C34.1598 10.6506 33.023 12.0147 29.8945 11.6328Z",
    fill: "#2E4369"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2188 11.642L28.074 1.49268H30.5204L28.6742 11.642H26.2188Z",
    fill: "#2E4369"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.207 1.49268H14.5807L15.3537 8.83182L18.4639 1.49268H20.8194L21.647 8.90457L24.6481 1.49268H27.0126L22.711 11.642H20.0191L19.146 4.65751L16.1722 11.642H13.5712L12.207 1.49268Z",
    fill: "#2E4369"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33878 4.1846L0.519531 6.87653H5.31226L5.81245 5.70336H3.38425L4.90301 4.1846L4.02086 2.66585H8.1406L4.33916 11.642H5.76697L10.0686 1.49268H1.75636L3.33878 4.1846Z",
    fill: "#00B9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWise);
export default __webpack_public_path__ + "static/media/wise.54b0a615162b8808e8b0f9678aa9f336.svg";
export { ForwardRef as ReactComponent };